// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip-module__root___uXdxb","arrow--hide":"Tooltip-module__arrow--hide___WD+0j","arrow":"Tooltip-module__arrow___vyKQK"};